module.exports = __webpack_public_path__ + "img/amex-data.916174b3.svg";